// =================================================================================
// File: src/pages/visitor/DiscoverMapPage.jsx
// Description: Interactive world map for discovering ceramic studios
// =================================================================================

import React from "react";
import MudoMapScreen from "../../components/Screens/MudoMapScreen";
import VisitorNavBar from "../../components/Common/VisitorNavBar";

/**
 * DiscoverMapPage - Full-page map view for visitors
 * 
 * Shows the global Mudo map with all public studios
 * Includes navigation back to discover home
 */
export default function DiscoverMapPage() {
  return (
    <div className="relative min-h-[100dvh] bg-slate-950">
      {/* Navigation Bar with Profile/Logout */}
      <VisitorNavBar showBackButton backTo="/discover" />
      
      {/* Map content with proper spacing for nav bar */}
      <div className="pt-20 h-[calc(100dvh-5rem)]">
        <MudoMapScreen hideHeader={false} />
      </div>
    </div>
  );
}
